import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTVideo from "../../VideojsWrapper"
import NRTButton from "../../../_common/_buttons/Button"
import ArrowRight from "../../../_common/_icons/ArrowRight"
import Rewind from "../../../_common/_icons/Rewind"
import AutoPlaySpinner from "../../../_ead/AutoplaySpinner"


class NRTEADVideo extends Component {

    state = {
        showOverlay: false,
        playing: false,
        ended: false,
        autoplaySeconds: null,
        removeOverlay:true ,
    }

    autoplayInterval = null


    componentDidMount() {


    }


    startAutoplayCount() {


        if (!this.props.nextContent)
            return

        this.setState({autoplaySeconds: 5},
            () => {

                this.autoplayInterval = setInterval(() => {

                    if (this.state.autoplaySeconds === 0) {
                        clearInterval(this.autoplayInterval)
                        this.props.onNextContentClick()
                    } else {
                        this.setState({
                            autoplaySeconds: this.state.autoplaySeconds - 1
                        })
                    }

                }, 1000)

            })

    }


    play() {
        this.refs.video.player.play()
    }


    restart = () => {
        this.refs.video.player.currentTime(0)
        this.play()
        this.hideEndOverlay()
    }

    showInfoOverlay = () => {
        this.setState({removeOverlay:false } , ()=>{
            this.setState({showOverlay: true})

        })
    }


    hideInfoOverlay = () => {
        this.setState({showOverlay: false}, ()=>{
            setTimeout(()=>{
                this.setState({removeOverlay:true })
            }, 500)
        })
    }


    showEndOverlay = () => {
        this.setState({ended: true})
    }

    hideEndOverlay = () => {
        clearInterval(this.autoplayInterval)
        this.setState({ended: false})
    }


    onVideoEnd = () => {

        this.showEndOverlay()
        if (this.props.autoplay)
            this.startAutoplayCount()

    }


    render() {

        const {
            showOverlay,
            removeOverlay,
            ended,
            autoplaySeconds,

        } = this.state

        const {
            title,
            section,
            prevContent,
            nextContent,
            onPrevContentClick,
            onNextContentClick,
            videoSrc,
            autoplay,
        } = this.props


        const cancelButton = (
            <div style={{marginTop: '2rem'}}>


                <NRTButton secondary
                           onClick={this.hideEndOverlay}
                           outline
                           noBorder>
                    Cancelar
                </NRTButton>


            </div>
        )


        return (
            <div className={'nrt-video'}
                 onMouseOver={this.showInfoOverlay}
                 onMouseLeave={this.hideInfoOverlay}>


                <div className="complete-overlay"
                     style={{
                         display: ended ? 'flex' : 'none'
                     }}
                >

                    {

                        autoplay ?
                            <React.Fragment>
                                <AutoPlaySpinner/>
                                <p>Indo para próximo conteudo em {autoplaySeconds} segundos.</p>

                                {cancelButton}
                            </React.Fragment>

                            :

                            <React.Fragment>
                                <div>


                                    <NRTButton secondary
                                               onClick={this.restart}
                                               outline
                                               noBorder>
                                        <Rewind width={32} height={32}/> Repetir vídeo
                                    </NRTButton>
                                </div>

                                <div>
                                    {
                                        nextContent &&
                                        <React.Fragment>


                                            <NRTButton onClick={onNextContentClick}
                                                       outline
                                                       noBorder>
                                                Ir para próximo conteudo: {nextContent.name} <ArrowRight height={16}/>
                                            </NRTButton>
                                        </React.Fragment>

                                    }
                                </div>


                                {cancelButton}
                            </React.Fragment>
                    }

                </div>


                {
                    !removeOverlay &&
                    <div className={'info-overlay'}
                         style={{
                             opacity: showOverlay ? 1 : 0,
                         }}>

                        <div className={'next-prev-buttons'}>

                            {
                                prevContent ?

                                    <NRTButton onClick={onPrevContentClick} outline noBorder>
                                        <ArrowRight height={22} style={{
                                            marginRight: 5,
                                            transform: 'rotate(180deg)'
                                        }}/>
                                        {prevContent.name}
                                    </NRTButton>
                                    : <span/>

                            }

                            {
                                nextContent &&
                                <NRTButton onClick={() => {
                                    onNextContentClick()
                                }}
                                           outline noBorder>
                                    {nextContent.name} <ArrowRight height={22} style={{
                                    marginLeft: 5
                                }}/>
                                </NRTButton>

                            }
                        </div>


                        <h3>{section}</h3>
                        <h1>{title}</h1>
                    </div>
                }


                <NRTVideo videoSrc={videoSrc}
                          ref={'video'}
                          onEnd={this.onVideoEnd}
                          onSeeked={this.hideEndOverlay}
                          onUserInactive={this.hideInfoOverlay}
                          autoplay={autoplay}
                          onPlay={this.hideEndOverlay}

                />

            </div>
        )
    }
}


NRTEADVideo.propTypes = {
    title: PropTypes.string.isRequired,
    section: PropTypes.string.isRequired,
    videoSrc: PropTypes.string.isRequired,
    autoplay: PropTypes.bool,
    prevContent: PropTypes.any,
    nextContent: PropTypes.any,
    onPrevContentClick: PropTypes.func,
    onNextContentClick: PropTypes.func,
}

NRTEADVideo.defaultProps = {
    autoplay: true,
}

export default NRTEADVideo



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/Video/index.js